import { OrderEs } from "@edp-models/ES/es-order.model";
import { Action } from "@ngrx/store";

export enum EOrderEsActions {
    GetOrderEs = "[Order] Get Order",
    SetOrderEs = "[Order] Set Order",
    GetOrderAPIError = "[Order] Get Order API Error",
    SetOrderAPIError = "[Order] Set Order API Error",
}

export class GetOrderEs implements Action {
    public readonly type = EOrderEsActions.GetOrderEs;
    constructor(public contractId: string) {}
}

export class GetOrderAPIError implements Action {
    public readonly type = EOrderEsActions.GetOrderAPIError;
    constructor(public error: Error) {}
}

export class SetOrderEs implements Action {
    public readonly type = EOrderEsActions.SetOrderEs;
    constructor(public payload: OrderEs) {}
}

export class SetOrderAPIError implements Action {
    public readonly type = EOrderEsActions.SetOrderAPIError;
    constructor(public payload: any) {}
}

export type OrderEsActions =
    | GetOrderEs
    | GetOrderAPIError
    | SetOrderAPIError
    | SetOrderEs;
